<template>
	<div class="full-height flex-column">
		<v-form
			v-if="!onBoardRegistrationSuccess"
			v-model="formIsValid"
			class="white"
		>
			<div
				class="form-heading title full-width"
				:style="{ backgroundColor: themeInputColor }"
			>
				Create an account
				<v-btn
					fab
					flat
					class="top-left-align pa-0 ma-0 z-index--2"
					@click="closeSignUp"
				>
					<v-icon color="#FFF">arrow_back</v-icon>
				</v-btn>
			</div>
			<v-tabs-items
				class="text-center px-4 pt-5 mt-3"
				v-model="activeTab"
			>
				<v-tab-item class="pa-2" value="tab-1">
					<div class="headline mb-4">
						Step 1
						<span class="subheading">( Mobile Verification )</span>
					</div>
					<v-layout row wrap class="full-width">
						<v-flex>
							<v-text-field
								id="nameBox"
								v-model="name"
								autocomplete="new-name"
								label="Company Name*"
								placeholder="Company Name"
								class="body-1 text-field-wrapper pt-4"
								:rules="[requiredRule]"
							></v-text-field>
						</v-flex>
					</v-layout>
					<v-layout row class="mb-2">
						<v-flex>
							<v-select
								:items="allLangData"
								label="Select Language*"
								v-model="langValueLocal"
								hide-details
								placeholder="Select Language"
								class="body-1 text-field-wrapper py-4"
								required
							></v-select>
						</v-flex>
					</v-layout>
					<v-layout>
						<v-flex>
							<v-text-field
								label="Email*"
								v-model="email"
								:rules="[checkValidEmail, requiredRule]"
								placeholder="Enter Email"
								class="body-1 text-field-wrapper pt-4"
								required
								autocomplete="new-email"
							></v-text-field>
						</v-flex>
					</v-layout>

					<v-layout>
						<v-flex>
							<v-text-field
								label="Phone number*"
								v-model="phone"
								autocomplete="new-phone"
								placeholder="Phone Number"
								class="body-1 text-field-wrapper pt-4"
								@keyup.enter="sendOTP"
							></v-text-field>
						</v-flex>
						<v-flex class="no-flex-grow allCenteredChild px-2">
							<v-btn
								v-if="!isUserVerified"
								small
								flat
								:loading="sendOTPLoading"
								:color="themeInputColor"
								:disabled="disableSendOtpButton"
								@click="sendOTP"
							>
								{{ authenticationId ? "Resend" : "Send" }}
								OTP
							</v-btn>
							<v-tooltip right v-else>
								<v-icon
									slot="activator"
									:color="themeInputColor"
									>check_circle</v-icon
								>
								<span>Verified</span>
							</v-tooltip>
						</v-flex>
					</v-layout>

					<v-layout v-if="!isUserVerified && onSendOTP">
						<v-flex>
							<v-text-field
								label="Enter OTP*"
								v-model="OTP"
								ref="OTPBox"
								placeholder="Enter OTP"
								class="body-1 text-field-wrapper pt-4"
								@keyup.enter="verifyOTP"
								autofocus
							></v-text-field>
						</v-flex>
						<v-flex class="allCenteredChild no-flex-grow px-2">
							<v-btn
								:color="themeInputColor"
								flat
								:loading="verifyOTPLoading"
								@click="verifyOTP"
								>Verify</v-btn
							>
						</v-flex>
					</v-layout>

					<v-layout v-if="showAppAgencyOption">
						<v-layout class="verCenteredChild pt-1 mb-2">
							<span
								class="subheading px-2 mb-3 pb-1 grey-color-text"
								>I am a</span
							>
							<v-radio-group
								:color="themeInputColor"
								v-model="appAgency"
								class="pa-0 ma-0"
								:rules="[requiredRule]"
							>
								<v-layout>
									<v-flex>
										<v-radio
											:color="themeInputColor"
											label="Moj Agency"
											value="MojAgency"
											class="my-0"
										></v-radio>
									</v-flex>
									<v-flex>
										<v-radio
											:color="themeInputColor"
											label="ShareChat Agency"
											class="my-0"
											value="ShareChatAgency"
										></v-radio>
									</v-flex>
								</v-layout>
							</v-radio-group>
						</v-layout>
					</v-layout>
				</v-tab-item>

				<v-tab-item class="pa-2" value="tab-2">
					<div class="headline mb-4">
						Step 2
						<span class="subheading">( Personal Details )</span>
					</div>

					<v-layout
						class="full-width pos-rel profile-card verCenteredChild mb-4"
					>
						<img
							:src="onBoardUser ? onBoardUser.coverPic : null"
							class="full-cover cover"
							alt="cover-pic"
						/>
						<div class="background-overlay-1 full-cover"></div>
						<div class="pos-abs verCenteredChild">
							<v-avatar size="75" class="mx-3">
								<img
									:src="
										onBoardUser
											? onBoardUser.profilePic
											: null
									"
									alt="profile-pic"
								/>
							</v-avatar>
							<div class="px-1">
								<div class="headline white--text">
									{{ this.name }}
								</div>
								<div class="heading white--text">
									@{{
										onBoardUser
											? onBoardUser.username
											: null
									}}
								</div>
							</div>
						</div>
					</v-layout>

					<v-layout class="mb-2">
						<v-flex>
							<v-text-field
								label="Choose Username*"
								v-model="dashboardUsername"
								placeholder="Enter Username"
								class="body-1 text-field-wrapper pt-4"
								autcomplete="new-dashboardUsername"
								:rules="[requiredRule]"
							></v-text-field>
						</v-flex>
					</v-layout>

					<v-layout class="mb-2">
						<v-flex>
							<v-text-field
								type="password"
								label="Password*"
								v-model="password"
								onpaste="return false;"
								oncopy="return false"
								placeholder="Create Password"
								class="body-1 text-field-wrapper pt-4"
								autocomplete="new-password"
								:rules="[requiredRule]"
							></v-text-field>
						</v-flex>
						<v-flex>
							<v-text-field
								type="password"
								label="Confirm Password*"
								onpaste="return false;"
								oncopy="return false"
								placeholder="Confirm Password"
								class="body-1 text-field-wrapper pt-4"
								v-model="confirmPassword"
								autocomplete="new-confirmPassword"
								:rules="[requiredRule, checkPasswordMatching]"
							></v-text-field>
						</v-flex>
					</v-layout>

					<v-layout
						v-if="!isMojAppAgencySignup"
						class="verCenteredChild pt-1 mb-2"
					>
						<span class="subheading px-2 mb-3 pb-1 grey-color-text"
							>Select Gender:</span
						>
						<v-radio-group
							:color="themeInputColor"
							v-model="gender"
							class="pa-0 ma-0"
							:rules="[requiredRule]"
						>
							<v-layout>
								<v-flex>
									<v-radio
										:color="themeInputColor"
										label="Male"
										value="M"
										class="my-0"
									></v-radio>
								</v-flex>
								<v-flex>
									<v-radio
										:color="themeInputColor"
										label="Female"
										class="my-0"
										value="F"
									></v-radio>
								</v-flex>
							</v-layout>
						</v-radio-group>
					</v-layout>
					<select-state-city-mm
						v-if="!isMojAppAgencySignup"
						:showFilter="false"
						@UPDATED_VALUES="updatedStateCityMM"
						:defaultState="selectedState"
						:defaultCity="selectedCity"
						:defaultMicroMarket="selectedMicroMarket"
					/>
					<v-layout
						v-if="!isMojAppAgencySignup"
						row
						class="mb-2 full-width"
					>
						<v-flex style="width: 50%">
							<v-select
								:items="storeTypes"
								label="Shop Type*"
								v-model="storeType"
								:value="storeType"
								placeholder="Shop Type"
								class="body-1 text-field-wrapper pt-4"
								required
								:disabled="
									isDistributorSignUp ||
										isDistributor ||
										isExecutiveSignUp
								"
							></v-select>
						</v-flex>
						<v-flex
							style="width: 50%"
							v-if="
								storeType !== jeet11Captain ||
									storeType !== jeet11TSM ||
									storeType !== jeet11RBM
							"
						>
							<v-select
								:items="incorporations"
								label="Incorporation*"
								v-model="incorporationType"
								placeholder="Incorporation"
								class="body-1 text-field-wrapper pt-4"
								:value="incorporationType"
								required
							></v-select>
						</v-flex>
					</v-layout>
					<v-layout
						row
						class="mb-2 full-width"
						v-if="
							storeType === jeet11Executive ||
								storeType === jeet11Retailer ||
								storeType === jeet11Agent ||
								storeType === jeet11Promoter ||
								storeType === jeet11Shopboy ||
								storeType === jeet11OnlineExecutive ||
								storeType === jeet11OnlineRetailer
						"
					>
						<v-select
							v-model="appTypes"
							:items="possibleAppTypes"
							label="App Type*"
							placeholder="App Type*"
							multiple
							chips
							class="body-1 text-field-wrapper pt-4"
							persistent-hint
						></v-select>
					</v-layout>
					<v-layout v-if="!isMojAppAgencySignup">
						<v-flex
							v-if="
								storeType !== jeet11Captain ||
									storeType !== jeet11TSM ||
									storeType !== jeet11RBM
							"
						>
							<v-select
								:items="shopCategories"
								label="Partner Category*"
								v-model="storeCategory"
								placeholder="Partner Category"
								class="body-1 text-field-wrapper pt-4"
								:value="storeCategory"
								required
							></v-select>
						</v-flex>
						<v-flex
							v-if="
								storeType === jeet11Executive ||
									storeType === jeet11OnlineExecutive
							"
						>
							<v-text-field
								type="text"
								label="Jeet11 Distributor Phone No"
								v-model="retailerDistributorNumber"
								onpaste="return false;"
								oncopy="return false"
								placeholder="Jeet11 Distributor Phone No"
								class="body-1 text-field-wrapper pt-4"
								:rules="[requiredRule, onlyDigitRule]"
								:disabled="partnerNumber ? true : false"
								maxlength="10"
							></v-text-field>
						</v-flex>
						<v-flex
							v-else-if="
								storeType === jeet11Retailer ||
									storeType === jeet11Promoter ||
									storeType === jeet11Agent ||
									storeType === jeet11Shopboy ||
									storeType === jeet11OnlineRetailer
							"
						>
							<v-text-field
								type="text"
								label="Jeet11 Executive Phone No"
								v-model="retailerExecutiveNumber"
								onpaste="return false;"
								oncopy="return false"
								placeholder="Jeet11 Executive Phone No"
								class="body-1 text-field-wrapper pt-4"
								:rules="[requiredRule, onlyDigitRule]"
								:disabled="partnerNumber ? true : false"
								maxlength="10"
							></v-text-field>
						</v-flex>
					</v-layout>
					<v-layout v-if="!isMojAppAgencySignup" class="full-width">
						<v-flex
							v-if="
								storeType === jeet11Retailer ||
									storeType === jeet11Promoter ||
									storeType === jeet11Agent ||
									storeType === jeet11Shopboy ||
									storeType === jeet11OnlineRetailer
							"
							style="width: 50%"
						>
							<v-select
								:items="retailerCategories"
								label="Category*"
								v-model="retailerCategory"
								:value="retailerCategory"
								placeholder="Category"
								class="body-1 text-field-wrapper pt-4"
								required
							></v-select>
						</v-flex>
						<v-flex
							v-if="storeType === jeet11Promoter"
							style="width: 50%"
						>
							<v-select
								:items="promoterShopTypes"
								item-text="value"
								item-value="key"
								label="Shop Category*"
								placeholder="Shop Category"
								class="body-1 text-field-wrapper pt-4"
								v-model="promoterShopCategory"
								:value="promoterShopCategory"
								required
							></v-select>
						</v-flex>
					</v-layout>
					<v-template
						v-if="
							storeType === jeet11Retailer ||
								storeType === jeet11Captain ||
								storeType === jeet11TSM ||
								storeType === jeet11Promoter ||
								storeType === jeet11RBM ||
								storeType === jeet11Agent ||
								storeType === jeet11Shopboy ||
								storeType === jeet11OnlineRetailer
						"
					>
						<v-layout class="verCenteredChild pt-1 mb-0">
							<span class="subheading mb-3 pb-1 grey-color-text"
								>Are you a shop owner?</span
							>
							<v-radio-group
								:color="themeInputColor"
								v-model="isShopOwner"
								class="pa-0 ma-0"
							>
								<v-layout>
									<v-flex>
										<v-radio
											:color="themeInputColor"
											label="Yes"
											value="true"
											class="my-0"
										></v-radio>
									</v-flex>
									<v-flex>
										<v-radio
											:color="themeInputColor"
											label="No"
											class="my-0"
											value="false"
										></v-radio>
									</v-flex>
								</v-layout>
							</v-radio-group>
						</v-layout>
						<v-layout>
							<v-flex>
								<v-select
									:items="possibleReferrers"
									label="Referrer Type"
									v-model="referrerType"
									:value="incorporationType"
									placeholder="Referrer Type"
									class="body-1 text-field-wrapper pt-4"
									required
								></v-select>
							</v-flex>
							<v-text-field
								label="Referrer Phone"
								v-model="referrerPhone"
								:rules="[validPhoneNoRule]"
								placeholder="Referrer Phone"
								class="body-1 text-field-wrapper pt-4"
							></v-text-field>
						</v-layout>
					</v-template>
				</v-tab-item>

				<v-tab-item value="tab-3">
					<div class="headline mb-4">
						Step 3
						<span class="subheading">( Upload Documents )</span>
					</div>
					<div
						v-for="(document, index) in documentTypes"
						:key="index"
					>
						<v-divider />
						<div
							class="d-flex justify-space-between align-baseline py-2"
						>
							<div class="subheading text-left pl-4">
								{{ document.name }}*
							</div>
							<div class="text-right pr-4">
								<image-preview
									:isTile="true"
									avatarSize="90px"
									:uploadKey="document.key"
									:imageSrcValue="document.value"
									:returnDataUri="true"
									@UPDATE_UPLOAD_VALUES="updateUploadValues"
								/>
							</div>
						</div>
					</div>
				</v-tab-item>
			</v-tabs-items>

			<v-layout class="px-4 justify-space-between mb-3 d-flex">
				<v-flex v-if="activeTab != 'tab-1'" class="no-flex-grow d-flex">
					<v-btn
						outline
						class="btn"
						:color="themeInputColor"
						@click="back"
						>Back</v-btn
					>
				</v-flex>
				<v-flex class="no-flex-grow d-flex">
					<v-btn
						:disabled="checkNextDisable"
						class="btn white--text"
						:loading="
							(activeTab === 'tab-3' &&
								onboardRegistrationLoading) ||
								(activeTab === 'tab-2' &&
									isMojAppAgencySignup &&
									onboardRegistrationLoading) ||
								(activeTab === 'tab-2' && isTsmValidating)
						"
						:color="themeInputColor"
						@click="next"
						>{{
							activeTab === "tab-3" ||
							(activeTab === "tab-2" && isMojAppAgencySignup)
								? "Submit"
								: "Next"
						}}</v-btn
					>
				</v-flex>
			</v-layout>
		</v-form>

		<div v-else class="pa-4 full-height">
			<v-layout class="full-height horCenteredChild" column>
				<v-flex class="no-flex-grow horCenteredChild">
					<v-icon :color="themeInputColor" :size="200"
						>check_circle</v-icon
					>
				</v-flex>
				<v-flex class="no-flex-grow text-center">
					<h5
						v-if="!isDistributorSignUp && !isExecutiveSignUp"
						class="headline grey--text"
					>
						We will get back to you after verifying your request.
						<strong>Remember your username and password</strong>
					</h5>
					<h5
						v-if="isDistributorSignUp || isExecutiveSignUp"
						class="headline grey--text"
					>
						Your request to add
						{{
							isDistributorSignUp
								? "executive"
								: isExecutiveSignUp
								? "retailer"
								: "captain"
						}}
						has been sent. You'll be able to see the
						{{
							isDistributorSignUp
								? "executive"
								: isExecutiveSignUp
								? "retailer"
								: "captain"
						}}once it is approved by our team
						<strong>
							Remember the username and password, retailer will be
							able to login using those details only.
						</strong>
					</h5>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
import * as utils from "@/utils";
import { mapState } from "vuex";

import SelectStateCityMM from "@/components/select-state-city-mm";
import {
	JEET_11_PARTNER,
	JEET_11_DISTRIBUTOR,
	JEET_11_EXECUTIVE,
	JEET_11_CAPTAIN,
	JEET_11_PROMOTER,
	JEET_11_TSM,
	JEET_11_RBM,
	JEET_11_AGENT,
	JEET_11_SHOPBOY,
	JEET_11_ONLINE_DSTR,
	JEET_11_ONLINE_EXECUTIVE,
	JEET_11_ONLINE_RETAILER
} from "@/store/config";

import {
	ONBOARD_USER_REGISTRATION,
	SEND_OTP,
	VERIFY_OTP,
	RESET_UPLOAD_MODULE,
	RESET_SIGNUP_MODULE
} from "@/store/action-types";

import ImagePreview from "@/components/ImagePreview";
import { MOJ_LOGO_BASE_64 } from "../constants";

export default {
	name: "SignUpForm",
	props: [
		"themeInputColor",
		"isDistributorSignUp",
		"isExecutiveSignUp",
		"partnerNumber",
		"isDistributor"
	],
	components: {
		"image-preview": ImagePreview,
		"select-state-city-mm": SelectStateCityMM
	},
	data() {
		return {
			formIsValid: false,
			activeTab: "tab-1",
			name: null,
			langValueLocal: null,
			gender: null,
			phone: null,
			OTP: null,
			onSendOTP: false,
			email: null,
			dashboardUsername: null,
			password: null,
			selectedState: null,
			selectedCity: null,
			selectedMicroMarket: null,
			confirmPassword: null,
			onlyDigitRule: v => utils._onlyDigitsRule(v),
			checkValidHandle: v => utils._checkValidHandle(v),
			requiredRule: v => utils._requiredRule(v),
			checkValidEmail: v => utils._checkValidEmail(v),
			validPhoneNoRule: v => utils._validPhoneNoRule(v),
			getFrontendStoreType: (v, shopType) =>
				utils.getFrontendStoreType(v, shopType),
			onBoardRegistrationSuccess: false,
			onboardRegistrationLoading: false,
			sendOTPLoading: false,
			verifyOTPLoading: false,
			storeTypes: [
				JEET_11_PARTNER,
				JEET_11_EXECUTIVE,
				JEET_11_DISTRIBUTOR,
				JEET_11_CAPTAIN,
				JEET_11_PROMOTER,
				JEET_11_TSM,
				JEET_11_RBM,
				JEET_11_AGENT,
				JEET_11_SHOPBOY,
				JEET_11_ONLINE_DSTR,
				JEET_11_ONLINE_EXECUTIVE,
				JEET_11_ONLINE_RETAILER
			],
			incorporations: ["Company", "Individual", "Partnership"],
			shopCategories: ["Normal", "AES"],
			promoterShopTypes: [
				{ key: "inShop", value: "In Shop" },
				{ key: "outShop", value: "Out Shop" }
			],
			storeType: this.isDistributorSignUp
				? JEET_11_EXECUTIVE
				: this.isExecutiveSignUp
				? JEET_11_PARTNER
				: JEET_11_DISTRIBUTOR,
			incorporationType: null,
			storeCategory: "Normal",
			retailerDistributorNumber: this.partnerNumber
				? this.partnerNumber.toString().substr(2)
				: null,
			retailerExecutiveNumber: this.partnerNumber
				? this.partnerNumber.toString().substr(2)
				: null,
			jeet11Retailer: JEET_11_PARTNER,
			jeet11Captain: JEET_11_CAPTAIN,
			jeet11TSM: JEET_11_TSM,
			jeet11Distributor: JEET_11_DISTRIBUTOR,
			jeet11Executive: JEET_11_EXECUTIVE,
			jeet11Promoter: JEET_11_PROMOTER,
			jeet11RBM: JEET_11_RBM,
			jeet11Agent: JEET_11_AGENT,
			jeet11Shopboy: JEET_11_SHOPBOY,
			jeet11OnlineDistributor: JEET_11_ONLINE_DSTR,
			jeet11OnlineExecutive: JEET_11_ONLINE_EXECUTIVE,
			jeet11OnlineRetailer: JEET_11_ONLINE_RETAILER,
			retailerCategory: "A",
			promoterShopCategory: "inShop",
			retailerCategories: ["A", "B", "C", "D", "E"],
			isShopOwner: null,
			possibleReferrers: utils.possibleReferrers,
			referrerType: null,
			referrerPhone: null,
			isTsmValid: true,
			isTsmValidating: false,
			possibleAppTypes: ["JEET11", "RUMMY"],
			appTypes: [],
			IDProof: null,
			agreement: null,
			showAppAgencyOption: false,
			appAgency: null
		};
	},
	mounted() {
		this.dashboardUsername = this.onBoardUser
			? this.onBoardUser.username
			: "";

		//re-setting the upload-media
		this.$store.dispatch(RESET_UPLOAD_MODULE.dispatch);
		this.$store.dispatch(RESET_SIGNUP_MODULE.dispatch);
	},
	computed: {
		...mapState({
			authenticationId: state => state.signUp.authenticationId,
			onBoardUser: state => state.signUp.onBoardUser,
			allLangData: state => state.common.allLangData.map(el => el.lang.S),
			COI: state => state.uploadMedia.COI
		}),
		isUserVerified() {
			return this.onBoardUser && this.phone === this.onBoardUser.phone;
		},
		checkPasswordMatching() {
			if (this.password && this.password === this.confirmPassword) {
				return true;
			}
			return "Passwords do not match.";
		},
		documentTypes() {
			return [
				{
					name:
						this.isDistributorSignUp || this.isExecutiveSignUp
							? "PAN Card"
							: "ID Proof",
					key: "IDProof",
					value: this.IDProof
				}
			].concat(
				...(this.isDistributorSignUp || this.isExecutiveSignUp
					? []
					: [
							{
								name: "Agreement",
								key: "agreement",
								value: this.agreement
							}
					  ])
			);
		},
		checkNextDisable() {
			if (this.activeTab === "tab-1") {
				// return false;
				return (
					!this.isUserVerified ||
					!this.langValueLocal ||
					!this.email ||
					!this.name ||
					!this.appAgency
				);
			} else if (this.activeTab === "tab-2") {
				if (this.isMojAppAgencySignup) {
					return (
						!this.dashboardUsername ||
						!this.password ||
						!this.confirmPassword ||
						this.password !== this.confirmPassword
					);
				}
				return (
					!this.dashboardUsername ||
					!this.password ||
					!this.appTypes ||
					!this.confirmPassword ||
					this.password !== this.confirmPassword ||
					!this.selectedState ||
					!this.selectedCity ||
					!this.selectedMicroMarket ||
					((this.storeType !== JEET_11_CAPTAIN ||
						this.storeType !== JEET_11_TSM ||
						this.storeType !== JEET_11_RBM) &&
						!this.incorporationType) ||
					((this.storeType === JEET_11_PARTNER ||
						this.storeType === JEET_11_AGENT ||
						this.storeType === JEET_11_SHOPBOY ||
						this.storeType === JEET_11_ONLINE_RETAILER) &&
						!this.retailerExecutiveNumber) ||
					((this.storeType === JEET_11_EXECUTIVE ||
						this.storeType === JEET_11_ONLINE_EXECUTIVE) &&
						!this.retailerDistributorNumber)
				);
			} else if (this.activeTab === "tab-3") {
				if (this.isDistributorSignUp || this.isExecutiveSignUp) {
					return !this.IDProof;
				}

				if (this.storeType !== JEET_11_CAPTAIN) {
					return !this.IDProof || !this.agreement;
				} else {
					return !this.IDProof || !this.agreement;
				}
			}
			return false;
		},
		disableSendOtpButton() {
			return (
				!this.name || !this.langValueLocal || !this.email || !this.phone
			);
		},
		isMojAppAgencySignup() {
			return this.appAgency === "MojAgency";
		}
	},
	methods: {
		getBackendStoreType(val) {
			if (
				val == JEET_11_PARTNER ||
				val === JEET_11_AGENT ||
				val === JEET_11_SHOPBOY ||
				val === JEET_11_ONLINE_RETAILER
			) {
				return "dstrRetail";
			}
			if (val == JEET_11_DISTRIBUTOR || val === JEET_11_ONLINE_DSTR) {
				return "dstr";
			}
			if (val === JEET_11_EXECUTIVE || val === JEET_11_ONLINE_EXECUTIVE) {
				return "executive";
			}
			if (val === JEET_11_CAPTAIN) {
				return "captain";
			}
			if (val === JEET_11_PROMOTER) {
				return "promoter";
			}
			if (val === JEET_11_TSM) {
				return "tsm";
			}
			if (val === JEET_11_RBM) {
				return "rbm";
			}
			return val;
		},
		requiredCoiDoc(val) {
			return (
				val !== JEET_11_CAPTAIN ||
				val !== JEET_11_TSM ||
				val !== JEET_11_RBM
			);
		},
		closeSignUp() {
			this.$emit("closeSignUp");
		},
		back() {
			const tabCount = parseInt(this.activeTab.split("-")[1], 10) - 1;
			const tab = tabCount < 0 ? 0 : tabCount;
			// console.log("tab: ", tab);
			this.activeTab = `tab-${tab}`;
		},
		next() {
			const tabCount = parseInt(this.activeTab.split("-")[1], 10) + 1;
			if (
				tabCount === 4 ||
				(tabCount === 3 && this.isMojAppAgencySignup)
			) {
				this.submitRegistration();
				return;
			}
			const tab = tabCount < 4 ? tabCount : 0;

			this.activeTab = `tab-${tab}`;
		},
		updateUploadValues({ key, file }) {
			const fr = new FileReader();
			fr.readAsDataURL(file);
			fr.addEventListener("load", () => {
				if (key === "IDProof") {
					this.IDProof = fr.result;
				} else if (key === "agreement") {
					this.agreement = fr.result;
				}
			});
		},
		updatedStateCityMM(updatedValues) {
			const {
				selectedState,
				selectedCity,
				selectedMicroMarket
			} = updatedValues;
			this.selectedState = selectedState;
			this.selectedCity = selectedCity;
			this.selectedMicroMarket = selectedMicroMarket;
		},

		sendOTP() {
			// this.onSendOTP = true;
			if (!this.sendOTPLoading) {
				this.sendOTPLoading = true;
				this.$store
					.dispatch(SEND_OTP.dispatch, {
						countryAreaCode: 91,
						phone: parseInt(this.phone, 10),
						name: this.name,
						language: this.langValueLocal
					})
					.then(() => {
						this.onSendOTP = true;
						this.sendOTPLoading = false;
						if (this.$refs.OTPBox) this.$refs.OTPBox.focus();
					})
					.catch(err => {
						console.error(err);
						this.sendOTPLoading = false;
					});
			}
		},

		verifyOTP() {
			if (!this.verifyOTPLoading) {
				this.verifyOTPLoading = true;
				this.$store
					.dispatch(VERIFY_OTP.dispatch, {
						otp: parseInt(this.OTP, 10),
						id: this.authenticationId,
						phone: this.phone,
						isDistributor: this.isDistributor
					})
					.then(() => {
						this.verifyOTPLoading = false;
						this.onSendOTP = false;
						this.showAppAgencyOption = true;
						// if (this.langValueLocal && this.email && this.name)
						// 	this.activeTab = "tab-2";
					})
					.catch(err => {
						this.verifyOTPLoading = false;
						console.error(err);
					});
			}
		},

		prefillData(newData) {
			const {
				city,
				state,
				microMarket,
				// gender,
				// GSTCertificate,
				// IDProof,
				// agreement,
				// COI,
				storeType,
				incorporationType,
				storeCategory,
				retailCategory,
				dstrPhone = "",
				isShopOwner,
				referrerType,
				referrerPhone,
				shopType
			} = newData || {};

			this.selectedState = state;
			this.selectedCity = city;
			this.selectedMicroMarket = microMarket;
			this.storeType = this.getFrontendStoreType(storeType, shopType);
			this.incorporationType = incorporationType;
			this.storeCategory = storeCategory;
			this.retailerCategory = retailCategory;
			this.promoterShopCategory = shopType;
			const transformedDstrNumber = (dstrPhone || "")
				.toString()
				.replace(/^91/, "");
			if (
				this.storeType === JEET_11_PARTNER ||
				this.storeType === JEET_11_AGENT ||
				this.storeType === JEET_11_SHOPBOY ||
				this.storeType === JEET_11_ONLINE_RETAILER
			) {
				this.retailerExecutiveNumber = transformedDstrNumber;
				this.isShopOwner = isShopOwner === true ? "true" : "false";
			}
			if (
				this.storeType === JEET_11_EXECUTIVE ||
				this.storeType === JEET_11_ONLINE_EXECUTIVE
			) {
				this.retailerDistributorNumber = transformedDstrNumber;
			}
			this.referrerType = referrerType;
			this.referrerPhone = referrerPhone.toString();
		},

		submitRegistration() {
			if (!this.onboardRegistrationLoading) {
				let toSend = {
					id: this.onBoardUser.id,
					password: this.password,
					city: this.isMojAppAgencySignup
						? "Nicobar"
						: this.selectedCity,
					state: this.isMojAppAgencySignup
						? "ANDAMAN & NICOBAR ISLANDS"
						: this.selectedState,
					micro_market: this.isMojAppAgencySignup
						? "Campbelbay"
						: this.selectedMicroMarket,
					language: this.langValueLocal,
					gender: this.isMojAppAgencySignup ? "M" : this.gender,
					GSTCertificate: this.isMojAppAgencySignup
						? MOJ_LOGO_BASE_64
						: this.GSTCertificate,
					IDProof: this.isMojAppAgencySignup
						? MOJ_LOGO_BASE_64
						: this.IDProof,
					agreement:
						this.isDistributorSignUp || this.isExecutiveSignUp
							? "NA"
							: this.isMojAppAgencySignup
							? MOJ_LOGO_BASE_64
							: this.agreement,
					COI:
						this.isDistributorSignUp ||
						this.isExecutiveSignUp ||
						this.storeType === JEET_11_CAPTAIN ||
						this.storeType === JEET_11_TSM ||
						this.storeType === JEET_11_RBM ||
						this.isMojAppAgencySignup
							? "NA"
							: this.COI,
					storeType: this.isMojAppAgencySignup
						? "captain"
						: this.getBackendStoreType(this.storeType),
					incorporationType:
						this.storeType !== JEET_11_CAPTAIN ||
						this.storeType !== JEET_11_TSM ||
						this.storeType !== JEET_11_RBM
							? this.isMojAppAgencySignup
								? "NA"
								: this.incorporationType
							: "NA",
					storeCategory: this.isMojAppAgencySignup
						? "NORMAL"
						: this.storeCategory,
					...(this.email ? { email: this.email } : {}),
					handle: this.dashboardUsername,
					appTypes: this.isMojAppAgencySignup ? [] : this.appTypes,
					...(this.storeType === JEET_11_PARTNER ||
					this.storeType === JEET_11_PROMOTER ||
					this.storeType === JEET_11_AGENT ||
					this.storeType === JEET_11_SHOPBOY ||
					this.storeType === JEET_11_ONLINE_RETAILER
						? {
								dstrPhone: `91${this.retailerExecutiveNumber}`,
								category: this.retailerCategory,
								...(this.isShopOwner
									? { isShopOwner: this.isShopOwner }
									: {}),
								...(this.referrerType
									? { referrerType: this.referrerType }
									: {}),
								...(this.referrerPhone
									? { referrerPhone: this.referrerPhone }
									: {}),
								shopType:
									this.storeType === JEET_11_ONLINE_RETAILER
										? "online"
										: this.storeType === JEET_11_AGENT
										? "agent"
										: this.storeType === JEET_11_SHOPBOY
										? "shopboy"
										: this.promoterShopCategory
						  }
						: {}),
					...(this.storeType === JEET_11_EXECUTIVE ||
					this.storeType === JEET_11_ONLINE_EXECUTIVE
						? {
								dstrPhone: `91${this.retailerDistributorNumber}`,
								...(this.storeType === JEET_11_ONLINE_EXECUTIVE
									? { shopType: "online" }
									: {})
						  }
						: {}),
					...(this.storeType === JEET_11_ONLINE_DSTR
						? {
								shopType: "online"
						  }
						: {}),
					...(this.retailerCategory
						? { retailCategory: this.retailerCategory }
						: {}),
					...(this.storeType === JEET_11_CAPTAIN ||
					this.storeType === JEET_11_TSM ||
					this.storeType === JEET_11_RBM
						? {
								...(this.referrerType
									? { referrerType: this.referrerType }
									: {}),
								...(this.referrerPhone
									? { referrerPhone: this.referrerPhone }
									: {})
						  }
						: {}),
					...(this.isMojAppAgencySignup
						? { shopType: "agency_moj" }
						: {})
				};
				this.onboardRegistrationLoading = true;
				this.$store
					.dispatch(ONBOARD_USER_REGISTRATION.dispatch, toSend)
					.then(() => {
						this.onboardRegistrationLoading = false;
						this.onBoardRegistrationSuccess = true;
					})
					.catch(err => {
						console.error(err);
						this.onboardRegistrationLoading = false;
					});
			}
		}
	},
	watch: {
		onBoardUser(newVal) {
			if (newVal) {
				this.dashboardUsername = newVal.username;
				this.gender = newVal.gender;
				if (newVal.userDetails) {
					this.prefillData(newVal.userDetails);
				}
			}
		},
		activeTab(newVal) {
			if (newVal === "tab-2") {
				const { signup, dNo, eNo, rNo } = this.$route.query;
				if (signup === "executive" && dNo && dNo.length === 10) {
					this.storeType = JEET_11_EXECUTIVE;
					this.retailerDistributorNumber = dNo;
				} else if (signup === "retailer" && eNo && eNo.length === 10) {
					this.storeType = JEET_11_PARTNER;
					this.retailerExecutiveNumber = eNo;
				} else if (signup === "captain" && rNo && rNo.length === 10) {
					this.referrerPhone = rNo;
					this.referrerType = "Captain";
					this.storeType = JEET_11_CAPTAIN;
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.grey-color-text {
	color: rgb(90, 72, 72);
}
.profile-card {
	height: 100px;
	border-radius: 8px;
	overflow: hidden;
}
.form-heading {
	text-align: center;
	color: #fff;
	padding: 18px;
	position: fixed;
	z-index: 1;
	max-width: 600px;
}
</style>
